import { Svg, SvgProps } from "./Svg";

function Ellipsis(props: SvgProps) {
  return (
    <Svg
      width={26}
      height={6}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      data-icon
      {...props}
    >
      <circle cx={3} cy={3} r={3} fill="#8A96B5" />
      <circle cx={13} cy={3} r={3} fill="#8A96B5" />
      <circle cx={23} cy={3} r={3} fill="#8A96B5" />
    </Svg>
  );
}

export default Ellipsis;
